import type { AcquisitionModel } from '@/domain/types';

/**
 * Progression normalisée d'une courbe de montée en charge, pour `t ∈ [0, 1]`.
 *
 * - `t = 0` (début de la montée) et `t = 1` (plateau atteint) sont toujours des points
 *   fixes : 0 et 1 respectivement. La fonction est croissante.
 * - `linear-ramp` : `f(t) = t` — pente constante.
 * - `s-curve` : `f(t) = t²(3 − 2t)` (smoothstep) — démarrage et arrivée à pente nulle.
 * - `constant` : plateau immédiat (`f(t) = 1`), équivalence avec `rampUpMonths = 0`.
 *
 * Pure, sans dépendance externe. Réutilisée par l'acquisition et la montée en
 * charge de l'effectif (cf. `acquisitionAtMonth`, `headcountAtMonth`).
 */
export function rampFactor(t: number, model: AcquisitionModel): number {
  if (model === 's-curve') {
    return t * t * (3 - 2 * t);
  }
  // linear-ramp et constant partagent la même primitive : `t`.
  return t;
}
